import { useMutation } from "react-query";

import { UserDto } from "@bcasmart/doxecure-commons/doxecureClientTypes";

import { patchUser } from "@services/users.service";

const usePatchUser = () => useMutation((values: UserDto) => patchUser(values));

export default usePatchUser;
